/**
 * 
 * @param target             - целевой елемент, набор элементов или селектор
 * @param preventClickIfDrag - не инициировать клик, если было смещение курсора после нажатия кнопки мыши
 * @param offset             - величина смещения в пикселах, превышение которой приведет к отмене клика
 */
export default function initLinkEmulator(
    target: Element|NodeListOf<Element>|string,
    preventClickIfDrag: boolean = false,
    offset: number = 0
) {
    if (typeof target === 'string') {
        target = document.querySelectorAll(target);
    }
    
    if (target instanceof NodeList) {
        target.forEach(button => appendClickHandler(button, preventClickIfDrag, offset));
    } else if (target instanceof Element) {
        appendClickHandler(target, preventClickIfDrag, offset);
    } else {
        console.error('initLinkEmulator: wrong target type');
    }
}

export function appendClickHandler(button: Element, preventClickIfDrag: boolean = false, offset: number = 0)
{
    let evt = null;

    if (preventClickIfDrag) {
        button.addEventListener('mousedown', e => evt = e);
    }

    button.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();

        let href = button.getAttribute('data-href');

        if (href === null || href === '') {
            return;
        }

        if (
            !preventClickIfDrag
            || evt && Math.abs(evt['layerX'] - e['layerX']) <= offset && Math.abs(evt['layerY'] - e['layerY']) <= offset
        ) {
            window.location.href = href;            
        }
    });
}
